/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import Plus from "components/icons/plus";
import Button from "components/button/button";
import Close from "components/icons/close";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";
import { AttributeNotFoundError } from "./errors";
import { t } from "i18n";

interface LoaderProps {
  loader: LoaderState;
  loadAttributes: () => void;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error }, loadAttributes }) => {
  if (loading) {
    return <Spinner message={t("attributes.messages.loading-list")} />;
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p>{t("attributes.messages.could-not-load-list")}</p>
          <p>
            <Button onClick={loadAttributes}>{t("attributes.cta.load-retry")}</Button>
          </p>
        </React.Fragment>
      );
    }

    if (error instanceof AttributeNotFoundError) {
      return (
        <React.Fragment>
          <Close width="48" height="48" />
          <p>{t("attributes.messages.not-found", { name: error.name })}</p>
        </React.Fragment>
      );
    }
  }

  return <p>{t("attributes.messages.unknown-error")}</p>;
};

export default Loader;
